import React, { ChangeEvent,useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import galleryIcon from "../../../../assets/icons/gallery.png";
import { uploadOneFiles } from "./../../../../../src/fileUploader/SingleFileUploader.js";
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';
import jwt_decode from 'jwt-decode';




function AddFoodCategoryDialog(props) {
  const [categoryName, setCategoryName] = useState('');
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [imageErr, setImageErr] = useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [userId, setUserId] = useState('');
  const [restaurantId, setRestaurantId] = useState('');
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        setUserId(decoded.UserId);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }


  }, []);

  const handleClose = () => {
    if(props.onClose){
      props.onClose()
    }
    props.onHandleAddItem(false);
    resetForm();
    
  };

  const resetForm = () => {
    setCategoryName('');
    setSelectedImages([]);
    setImageFiles([]);
    setImageErr(false);
  };

  const fileUpload = async () => {
    var Url = '';
    if (imageFiles.length == 0) {
      setImageErr(true);
    }
    for (let i = 0; i < imageFiles.length; i++) {
      var res = await uploadOneFiles(imageFiles[i]);
      var obj = {
        Id: "1234",
        FoodItemId: "1234",
        ItemImagePath: res[0],
        CreationId: "1234",
      };
      //Url=obj;
    }
    // setImageUrl(Url)
    FoodCategoryView.CategoryImagePath = obj?.ItemImagePath;
  };


  const[FoodCategoryView, setfoodCategoryView]=useState({
    Id:'',
    CategoryName: '',
    IsActive: true,
    CreatorId: ''  ,
    CreationDate: '',
    ModifierId: '',
    ModificationDate: '',
    CategoryImagePath:'',
    CreatorRestaurantId:''
});


  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 1 - selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        setImageFiles((prevItems) => [...prevItems, file]);

        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...selectedImages, ...imagesArray];
            setSelectedImages(updatedImages);
          }
        };
        reader.readAsDataURL(file);
      }
    }
    setImageErr(false);
  };

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...selectedImages];
    const updatedImageFiles = [...imageFiles];
    updatedImages.splice(index, 1);
    updatedImageFiles.splice(index, 1);
    setImageFiles(updatedImageFiles);
    setSelectedImages(updatedImages);
  };

  const handleSubmit = async () => {
    if (props?.isSubmitting) return;
    props?.setIsSubmitting(true);

    let valid = true;

    if (categoryName== "" || categoryName == undefined || categoryName == null) {
      valid = false;
      toast.error("Category Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (selectedImages.length === 0) {
      valid = false;
      toast.error("Image is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (valid) {
      try {

        FoodCategoryView.Id='';
        FoodCategoryView.CategoryName=categoryName;
        FoodCategoryView.IsActive=true;
        FoodCategoryView.CreatorId= userId;
        FoodCategoryView.CreationDate=new Date().toISOString();
        FoodCategoryView.ModifierId=userId;
        FoodCategoryView.ModificationDate=new Date().toISOString();
        FoodCategoryView.CreatorRestaurantId= Restauranttoken.id;


        // const formData = new FormData();
        // if (imageFiles.length > 0) {
        //   formData.append('image', imageFiles[0]); 
        // }

        // // Make the API call
        // const response = await axios.post('/api/FoodCategory/addFoodCategory', formData, {
        //   headers: {
        //     'Content-Type': 'multipart/form-data'
        //   }
        // });


        await fileUpload()

        console.log('Api hit')
        
        axios({
            method: 'post',
            url: apiAddress + '/api/FoodCategory/addFoodCategory',
            data: FoodCategoryView                
        })            
            .then((response) => {
                console.log(response)

                toast.success("Successfully Saved", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                toast.success("Category added successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });

                // props.onHandleAddItem(false)
                props?.setIsSubmitting(false);
                handleClose();
            });

       


      } catch (error) {
        console.error('Error adding category:', error);
        toast.error("Failed to add category", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  return (
    <div>
      <Dialog fullWidth={true} open={props.open} onClose={handleClose}>
        <ToastContainer />
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Add New Category</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Category Name
                                </Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <TextAreaComponents label={'Category Name'} value={setCategoryName} val={categoryName}></TextAreaComponents>
                            </Grid>
                        </Grid>
             


            {/* <Grid container sx={{ padding: '2rem' }}>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  label='Category Name'
                  variant='outlined'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                />
              </Grid>
            </Grid> */}
                        <Grid container sx={{ padding: '0.5rem' }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: '1rem' }}>
                          Image
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Button
                          variant="contained"
                          component="label"
                          //   color="primary"
                          style={{ backgroundColor: 'white', color: 'gray' }}
                        >
                          <img
                            src={galleryIcon}
                            alt="gallery-Icon"
                            style={{ width: '2rem' }}
                          />
                          Upload
                          <input
                            hidden
                            accept="image/*"
                            multiple
                            type="file"
                            onChange={handleImageUpload}
                            disabled={selectedImages.length >= 1}
                          />
                        </Button>

                      </Grid>
                      {/* image show start */}
                      <Grid container sx={{ padding: '0.5rem' }}>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={9}>
                          <Grid container spacing={2}>
                          {selectedImages.map((image, index) => (
                              <Grid item xs={2} sm={2} md={2} key={index}>
                              {/* <Paper> */}
                              <div
                                  style={{
                                  position: 'relative',
                                  paddingTop: '20px',
                                  }}
                              >

                        <img
                        src={image}
                            alt={`Preview ${index + 1}`}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'cover',
                        }}
                        />
                        <IconButton
                        style={{
                            position: 'absolute',
                            top: '-6px',
                            right: '-23px',
                            color: 'gray',
                        }}
                        onClick={() => handleDeleteImage(index)}
                        >
                        <CancelIcon />
                        </IconButton>
                    </div>
                    {/* </Paper> */}
                    </Grid>
                ))}
                </Grid>
            </Grid>
            </Grid>
            {/* image show end */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} color="primary" disabled={props.isSubmitting}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddFoodCategoryDialog;